// ContactUs.jsx
import React, { useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SendIcon from "@mui/icons-material/Send";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Link } from "react-router-dom";
import api from "../../utils/api";

import "./ContactUs.scss";
import { useLanguage } from "../../context/LanguageContext";
import { toast } from "react-toastify";

const ContactUs = () => {
  const { t, dir } = useLanguage();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    type: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate name (more than 3 letters)
    if (!formData.name || formData.name.trim().length <= 3) {
      newErrors.name =
        dir === "rtl"
          ? "يجب أن يحتوي الاسم على أكثر من 3 أحرف"
          : "Name must be more than 3 characters";
    }

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || !emailRegex.test(formData.email)) {
      newErrors.email =
        dir === "rtl"
          ? "يرجى إدخال بريد إلكتروني صالح"
          : "Please enter a valid email address";
    }

// Validate phone number (KSA format: 05xxxxxxxx)
    const phoneRegex = /^05\d{8}$/;
    if (!formData.phoneNumber || !phoneRegex.test(formData.phoneNumber)) {
      newErrors.phoneNumber =
        dir === "rtl"
          ? "يجب أن يكون رقم الهاتف بتنسيق 05xxxxxxxx"
          : "Phone number must be in format 05xxxxxxxx (e.g., 0506070810)";
    }

    // Validate message (more than 10 letters)
    if (!formData.message || formData.message.trim().length <= 10) {
      newErrors.message =
        dir === "rtl"
          ? "يجب أن تحتوي الرسالة على أكثر من 10 أحرف"
          : "Message must be more than 10 characters";
    }

    // Validate type (subject)
    if (!formData.type) {
      newErrors.subject =
        dir === "rtl" ? "يرجى اختيار الموضوع" : "Please select a subject";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form before submission
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Send data to the API endpoint
      await api.post("/support-questions", formData);
      toast.success(
        dir === "rtl"
          ? "شكرًا لتواصلك معنا! لقد استلمنا رسالتك وسنقوم بالرد عليك في أقرب وقت ممكن."
          : "Thank you for contacting us! We have received your message and will get back to you as soon as possible."
      );
      // Reset form after successful submission
      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        type: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(
        dir === "rtl"
          ? "حدث خطأ أثناء إرسال النموذج. يرجى المحاولة مرة أخرى."
          : "An error occurred while submitting the form. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-us-container" dir={dir}>
      <div className="container">
        <header className="contact-header">
          <h1 className="page-title">{t("contactUs")}</h1>
          <p className="page-subtitle">{t("contactUsSubtitle")}</p>
        </header>

        <div className="contact-paper">
          <div className="contact-grid">
            {/* Contact Info Section */}
            <div className="contact-info-section">
              <div className="contact-info-content">
                <h2 className="contact-info-title">
                  {t("contactInformation")}
                </h2>

                <div className="contact-info-divider"></div>

                <div className="contact-info-items">
                  <div className="contact-info-item">
                    <div className="icon-wrapper">
                      <LocationOnIcon className="contact-icon" />
                    </div>
                    <div>
                      <h3 className="contact-label">{t("address")}</h3>
                      <p className="contact-text">{t("officeAddress")}</p>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="icon-wrapper">
                      <PhoneIcon className="contact-icon" />
                    </div>
                    <div>
                      <h3 className="contact-label">{t("phone")}</h3>
                      <p className="contact-text" style={{}}>
                        0536785505
                      </p>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="icon-wrapper">
                      <EmailIcon className="contact-icon" />
                    </div>
                    <div>
                      <h3 className="contact-label">{t("email")}</h3>
                      <p className="contact-text">houfalmanazel@gmail.com</p>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="icon-wrapper">
                      <AccessTimeIcon className="contact-icon" />
                    </div>
                    <div>
                      <h3 className="contact-label">{t("workingHours")}</h3>
                      <p className="contact-text">{t("workingDays")}</p>
                    </div>
                  </div>
                </div>

                <div className="social-media">
                  <h3 className="social-title">{t("followUs")}</h3>
                  <div className="social-icons">
                    <Link to="#" className="social-icon facebook">
                      <FacebookIcon className="icon" />
                    </Link>
                    <Link to="#" className="social-icon twitter">
                      <TwitterIcon className="icon" />
                    </Link>
                    <Link to="#" className="social-icon instagram">
                      <InstagramIcon className="icon" />
                    </Link>
                    <Link to="#" className="social-icon whatsapp">
                      <WhatsAppIcon className="icon" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form Section */}
            <div className="contact-form-section">
              <form onSubmit={handleSubmit} className="contact-form">
                <h2 className="form-title">{t("sendMessage")}</h2>

                <div className="form-divider"></div>

                <div className="form-grid">
                  <div className="form-group">
                    <div className="form-field">
                      <label htmlFor="name">{t("fullName")} *</label>
                      <input
                        id="name"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={errors.name ? "error" : ""}
                        required
                        placeholder={
                          dir === "rtl"
                            ? "أدخل اسمك الكامل"
                            : "Enter your full name"
                        }
                      />
                      {errors.name && (
                        <p className="error-text">{errors.name}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="form-field">
                      <label htmlFor="email">{t("email")} *</label>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className={errors.email ? "error" : ""}
                        required
                        placeholder={
                          dir === "rtl"
                            ? "أدخل بريدك الإلكتروني"
                            : "Enter your email"
                        }
                      />
                      {errors.email && (
                        <p className="error-text">{errors.email}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="form-field">
                      <label htmlFor="phoneNumber">{t("phone")} *</label>
                      <input
                        id="phoneNumber"
                        type="tel"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        className={errors.phoneNumber ? "error" : ""}
                        required
                        placeholder="966xxxxxxxxx"
                      />
                      {errors.phoneNumber && (
                        <p className="error-text">{errors.phoneNumber}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="form-field">
                      <label htmlFor="type">{t("subject")} *</label>
                      <select
                        id="subject"
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        className={errors.subject ? "error" : ""}
                        required
                      >
                        <option value="">{t("chooseSubject")}</option>
                        <option value="general_inquiry">
                          {t("generalInquiry")}
                        </option>
                        <option value="technical_support">
                          {t("technicalSupport")}
                        </option>
                        <option value="suggestion">{t("suggestion")}</option>
                        <option value="complaint">{t("complaint")}</option>
                        <option value="other">{t("other")}</option>
                      </select>
                      {errors.subject && (
                        <p className="error-text">{errors.subject}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group full-width">
                    <div className="form-field">
                      <label htmlFor="message">{t("message")} *</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows={6}
                        className={errors.message ? "error" : ""}
                        required
                        placeholder={
                          dir === "rtl"
                            ? "أدخل رسالتك هنا..."
                            : "Enter your message here..."
                        }
                      ></textarea>
                      {errors.message && (
                        <p className="error-text">{errors.message}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group full-width">
                    <button
                      type="submit"
                      className="submit-button"
                      disabled={isSubmitting}
                    >
                      <span>
                        {isSubmitting
                          ? t("sending") || "Sending..."
                          : t("sendMessage")}
                      </span>
                      <SendIcon className="send-icon" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
